// wmtsLayers — registry of the EXTERNAL WMTS map works an archive may show (today only swisstopo/Dufour).
//
// One source for tile address, display name, archive assignment and extent. It replaces three scattered spots:
//   - index.js `WMTSBaseMapImages`            (archive → layer name)
//   - GoogleMapsAdapter.getWMTSImageMapType() (switch-case with the tile address)
//   - GoogleMapsAdapter.setWMTSMapOverlay()   (its own white checkbox control)
// The layers now appear as regular entries in the OV panel list (group "extern"), see OverlayPanelController.
//
// Still hardcoded on purpose: the archive assignment lives in exactly one place instead of three. Moving it to the
// server (get_overlays already knows Archive::Id()) is the intended next step — the field shapes below are chosen so
// a server response can replace this array 1:1.

/**
 * @typedef {Object} WmtsLayer
 * @property {string}   key         stable id fragment → panel item id 'wmts:<key>'
 * @property {string}   name        display name in the list
 * @property {number[]} archiveIds  archives that get this layer
 * @property {Object}   tiles       tile address (see buildWmtsImageMapType)
 * @property {Object}   bounds      extent for the "center" button, in get_overlays field names
 */

export const WMTS_LAYERS = [
    {
        key: 'dufour',
        name: 'Dufour (swisstopo)',
        archiveIds: [39, 809],
        tiles: {
            baseUrl: 'https://wmts.geo.admin.ch',
            version: '1.0.0',
            layer: 'ch.swisstopo.hiks-dufour',
            style: 'default',
            tileMatrixSet: '3857',
            format: 'png',
            minZoom: 0,
            maxZoom: 19
        },
        // Extent of the map work = Switzerland. Only used by the "center" button (fitBounds). Field names match the
        // get_overlays rows so the panel's jumpToOverlay() works unchanged. TODO: confirm the exact swisstopo extent.
        bounds: { lat_southwest: 45.818, lng_southwest: 5.956, lat_northeast: 47.808, lng_northeast: 10.492 }
    }
];

/** All WMTS layers configured for this archive (empty array = archive has none). */
export function wmtsLayersForArchive(archiveId) {
    const id = parseInt(archiveId, 10);
    if (!id) { return []; }
    return WMTS_LAYERS.filter((l) => l.archiveIds.some((a) => parseInt(a, 10) === id));
}

/**
 * Builds the google ImageMapType for a layer config. Same tile-URL scheme as the former
 * GoogleMapsAdapter.createWmtsImageMapType (moved here unchanged).
 */
export function buildWmtsImageMapType(google, cfg, opacity) {
    const t = cfg.tiles;
    const imt = new google.maps.ImageMapType({
        getTileUrl: ({ x, y }, z) =>
            `${t.baseUrl}/${t.version}/${t.layer}/${t.style || 'default'}/current/${t.tileMatrixSet}/${z}/${x}/${y}.${t.format}`,
        tileSize: new google.maps.Size(256, 256),
        minZoom: t.minZoom != null ? t.minZoom : 0,
        maxZoom: t.maxZoom != null ? t.maxZoom : 19,
        opacity: opacity != null ? opacity : 1,
        name: 'WMTS-Overlay'
    });
    imt._customName = 'WMTS-Overlay';
    return imt;
}
